import React from "react";
import "./StartupProjects.scss";
import {bigProjects} from "../../portfolio";
import {Fade} from "react-reveal";

export default function StartupProject() {
  const websites = [
    "SmartGarage AI",
    "CampusMarket Hub",
    "Supervision System",
    "VoiceAuth Login System",
    "AgriConnect Platform",
    "TelAnalytics Dashboard",
    "CloudBridge System",
    "SentimentScope AI",
    "PlateDetect Vision",
    "BizConnect Marketplace",
    "LearnSmart Platform",
    "ScheduleSync System",
    "DataInsight Hub",
    "StudentLink Network",
    "TradeFlow System",
    "Synaptic Hub",
    "ConnectX Platform",
    "NextGen Solutions"
  ];

  if (!bigProjects.display) {
    return null;
  }

  return (
    <Fade bottom duration={1000} distance="20px">
      <section className="websites-section" id="projects">
        <div className="websites-inner">
          <span className="websites-bg-word" aria-hidden="true">
            MY WEBSITES
          </span>
          <span className="websites-slashes" aria-hidden="true">
            {"//"}
          </span>

          <div className="websites-intro">
            <span className="websites-kicker">About Me</span>
            <h1>
              My <span>Websites</span>
            </h1>
            <p>
              These are some of the websites and systems I've worked on-built,
              managed, or contributed to through freelance and collaborations.
              They showcase my journey in creating practical and impactful tech
              solutions.
            </p>
          </div>

          <div className="website-development-word" aria-hidden="true">
            Website Development
          </div>

          <div className="websites-list-panel">
            <ol>
              {websites.map(website => (
                <li key={website}>{website}</li>
              ))}
            </ol>
          </div>
        </div>
      </section>
    </Fade>
  );
}
